import { render, staticRenderFns } from "./ProductFilterSidebar.vue?vue&type=template&id=3065c316&scoped=true"
import script from "./ProductFilterSidebar.vue?vue&type=script&lang=js"
export * from "./ProductFilterSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductFilterSidebar.vue?vue&type=style&index=0&id=3065c316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065c316",
  null
  
)

export default component.exports